import { axios } from './axios';

/**
 * fetch all function.
 *
 * @return {Promise<import("axios").AxiosResponse>} return axios response.
 */
export const fetchDashboardData = async (params = {}) => {
    return new Promise(async (res, rej) => {
        try {
            var response = await axios.get('/common/dashboard', { params });
            res(response.data.result);
        } catch (error) {
            rej(error);
        }
    });
};

/**
 * fetch recent activities with pagination
 *
 * @return {Promise<import("axios").AxiosResponse>} return axios response.
 */
export const fetchRecentActivities = async (params = {}) => {
    return new Promise(async (res, rej) => {
        try {
            var response = await axios.get('/common/dashboard/recent-activities', {
                params,
            });
            res(response.data.result);
        } catch (error) {
            rej(error);
        }
    });
};

/**
 * fetch performance metrics with pagination
 *
 * @return {Promise<import("axios").AxiosResponse>} return axios response.
 */
export const fetchPerformanceMetrics = async (params = {}) => {
    return new Promise(async (res, rej) => {
        try {
            var response = await axios.get('/common/dashboard/performance-metrics', {
                params,
            });
            res(response.data.result);
        } catch (error) {
            rej(error);
        }
    });
};

/**
 * fetch distinct script names
 *
 * @return {Promise<import("axios").AxiosResponse>} return axios response.
 */
export const fetchScriptNames = async () => {
    return new Promise(async (res, rej) => {
        try {
            var response = await axios.get('/common/dashboard/script-names');
            res(response.data.result);
        } catch (error) {
            rej(error);
        }
    });
};
